import { CoverageGolfCartValue } from "@covertree/new-business-graphql";

export function mapNumberEnumToNumber(
  enumValue?: CoverageGolfCartValue
): number {
  switch (enumValue) {
    case CoverageGolfCartValue.One:
      return 1;
    case CoverageGolfCartValue.Two:
      return 2;
    case CoverageGolfCartValue.Three:
      return 3;
    case CoverageGolfCartValue.Four:
      return 4;
    case CoverageGolfCartValue.Five:
      return 5;
    default:
      return 0;
  }
}
